import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Helmet } from 'react-helmet';

import NavBar from '../../nav/NavBar';
import { searchTeachers } from '../../../shared/requests/UserRequests';
import MySnackbarContentWrapper from '../../../shared/snackbars/MySnackbarContentWrapper';
import { truncate, createProfileRoute } from '../../../shared/Helpers';
import profilePlaceholder from '../../../static/img/profile_placeholder.png';


const styles = theme => ({
  layout: {
    flexGrow: 1,
    // display: 'flex',
  },
  content: {
    // minHeight: '100vh',
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.up(800 + theme.spacing(3 * 2))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    marginTop: theme.spacing(4),
  },
  header: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
  appBarSpacer: theme.mixins.toolbar,
  searchWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  textField: {
    margin: theme.spacing(),
  },
  searchButton: {
    margin: theme.spacing(),
    marginTop: theme.spacing(2),
  },
  listWrapper: {
    justifyContent: 'center',
    marginTop: theme.spacing(4),
    width: '100%',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50vh',
  },
  paper: {
    maxWidth: '100%',
    padding: theme.spacing(3),
    margin: theme.spacing(2),
  },
  avatar: {
    height: 140,
    width: 140,
    margin: theme.spacing(),
    marginBottom: theme.spacing(2),
  },
  name: {
    fontSize: 18,
    letterSpacing: 2,
    textTransform: 'uppercase',
    fontWeight: 'bold',
    textDecoration: 'none',
    color: theme.palette.primary.dark,
    '&:visited': {
      color: theme.palette.primary.dark,
    },
    textAlign: 'center',
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    [theme.breakpoints.up(800)]: {
      maxHeight: '48px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.secondary.main,
  },
  certImg: {
    height: 48,
    width: 48,
    [theme.breakpoints.down(800)]: {
      height: 30,
      width: 30,
    },
  },
  noResults: {
    textAlign: 'center',
  },
  profileSection: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  rightSide: {
    height: '100%',
  },
  form: {
    [theme.breakpoints.down(600)]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
});

class Finder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      query: '',
      teachers: [],
      hasSearched: false,
      snackbarOpen: false,
      snackbarVariant: '',
      snackbarMessage: '',
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {

  }

  handleChange(e) {
    this.setState({
      query: e.target.value,
    });
  }

  handleSearch(e) {
    e.preventDefault();
    const { query } = this.state;
    this.setState({
      loading: true,
      hasSearched: true,
    });
    searchTeachers(query)
      .then((response) => {
        console.log('got teachers');
        console.log(response.data);
        this.setState({
          teachers: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        console.log('failed to get teachers');
        console.log(error.response);
        this.setState({
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'something went wrong..',
        });
      });
  }

  handleClose(e, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarOpen: false });
  }

  render() {
    const { classes } = this.props;
    const {
      teachers,
      loading,
      query,
      hasSearched,
      snackbarOpen,
      snackbarVariant,
      snackbarMessage,
    } = this.state;

    return (
      <div className={classes.layout}>

        <Helmet>
          <title>Nia Teacher Finder | Dance Fitness, Live Yoga and Much More</title>
          <meta name="description" content="Nia's teacher finder helps you find the right instructor for your journey into complete wellness for the mind, body, and soul. Learn more here." />
          <meta name="keywords" content="low, impact, dance, workout, live, yoga, classes, online" />
        </Helmet>

        <NavBar />
        <div className={classes.appBarSpacer} />
        <div className={classes.content}>
          <Typography className={classes.header} color="textSecondary" variant="h4">Find a Teacher</Typography>

          {/* SEARCH */}
          <div className={classes.searchWrapper}>
            <form onSubmit={this.handleSearch} className={classes.form}>
              <TextField
                label="Teacher Name"
                id="ountlined-query"
                onChange={this.handleChange}
                className={classes.textField}
                value={query}
                variant="outlined"
                helperText="ex: Debbie Rosas"
              />
              <Button
                onClick={this.handleSearch}
                variant="contained"
                color="secondary"
                className={classes.searchButton}
                size="large"
                disabled={!query}
              >
                Search
              </Button>
            </form>
          </div>
          {/* LIST */}
          {loading
            ? (
              <div className={classes.loadingContainer}>
                <CircularProgress color="secondary" />
              </div>
            )
            : (
              <div className={classes.listWrapper}>
                <React.Fragment>
                  {teachers.length > 0
                    ? (
                      <React.Fragment>
                        {teachers.map(teacher => (
                          <Paper key={teacher.id} className={classes.paper}>
                            <Grid container spacing={2}>
                              <Grid item sm={3} xs={12}>
                                <div className={classes.profileSection}>
                                  <Avatar src={teacher.userInfo.profile_img ? teacher.userInfo.profile_img : profilePlaceholder} alt="profile img" className={classes.avatar} />
                                  <Link className={classes.link} to={createProfileRoute(teacher.username)}><Typography color="textSecondary" variant="subtitle1" className={classes.name}>{teacher.first_name + ' ' + teacher.last_name}</Typography></Link>
                                </div>
                              </Grid>
                              <Grid className={classes.certIcons} item sm={9} xs={12}>
                                <Grid container spacing={1} justifyContent="space-between" className={classes.rightSide}>
                                  <Grid item xs={12} className={classes.fullHeight}>
                                    {teacher.userCertifications.map((cert) => {
                                      if (cert.cert_level.img) {
                                        return (
                                          <Tooltip key={cert.id} title={cert.cert_level.level}>
                                            <img src={cert.cert_level.img} alt="" className={classes.certImg} />
                                          </Tooltip>
                                        );
                                      }
                                      return null;
                                    })}
                                  </Grid>
                                  <Grid item xs={12}>
                                    <Typography className={classes.description} color="textSecondary" variant="subtitle1">Description:</Typography>
                                    <Typography>{truncate(teacher.userInfo.description, 100)}</Typography>
                                  </Grid>
                                  <Grid className={classes.actions} item xs={12}>
                                    <React.Fragment>
                                      <Button variant="contained" color="secondary" href={createProfileRoute(teacher.username)}>View Profile</Button>
                                    </React.Fragment>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>

                          </Paper>
                        ))}
                      </React.Fragment>
                    )
                    : (
                      <React.Fragment>
                        {hasSearched
                          ? ( // display "no results text"
                            <Typography variant="h6" color="textSecondary" className={classes.noResults}>No Results..</Typography>
                          )
                          : ( // initial page load, dont show text yet
                            null
                          )
                        }
                      </React.Fragment>
                    )
                  }
                </React.Fragment>
              </div>
            )
          }
        </div>
        {/* SNACKBAR */}
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={this.handleClose}
        >
          <MySnackbarContentWrapper
            onClose={this.handleClose}
            variant={snackbarVariant}
            message={snackbarMessage}
          />
        </Snackbar>
      </div>
    );
  }
}

Finder.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Finder);
